module.exports = __webpack_public_path__ + "static/media/aditivoPet.304ca691.pdf";